import React, { Component } from 'react';
import { Input, Container, Row, Col, Label } from 'reactstrap';
import Axios from 'axios'
import HsmErrorAlert from './HsmErrorAlert'
import NormalButton from '../../components/NormalButton'
import ReactErrorTop from '../../components/ReactErrorTop'
import ReactLoadingTop from '../../components/ReactLoadingTop'

class HsmCertificateInput extends Component {

  constructor() {
    super();

    this.state = {
      loading: false,
      autoFind:true,
      typeList: ["starcos","akis","gemsafe","seimens","aladdin"],
      selectedIndex:0
    };

    this.loadCertificatesClicked = this.loadCertificatesClicked.bind(this);
    this.changed = this.changed.bind(this);
    this.handleChangeSmartCartBrand = this.handleChangeSmartCartBrand.bind(this);
    this.defaultHsmType = "akis";

    this.axios = Axios.create({
      baseURL: "http://127.0.0.1:9999",
      timeout: 10000
    });
  }

  componentDidMount() {
  }

  loadCertificatesClicked(selectedIndex) {
    if (this.props.togglePinInput) {
      this.props.togglePinInput(true);
    }

    let {autoFind} = this.state;
    console.log("selectedIndex",selectedIndex);
    let hsmType = autoFind ? this.state.typeList[selectedIndex] : ((this.props.value && this.props.value.hsmType) || this.defaultHsmType);
    let url = "/certificate?hsmtype=" + hsmType;

    this.setState({
      loading: true,
      certificateList: null
    });

    this.axios.get(url)
      .then((response) => {

        let certificateList = response.data.certificate.filter((element) => {
          return element.keyUsage.some((element2) => {
            return element2 === "DIGITAL_SIGNATURE";
          });
        });

        this.setState({
          loading: false,
          certificateList: certificateList
        });

        this.changed("certificate",  certificateList[0],selectedIndex);
      })
      .catch((error) => {
        console.log("selectedIndex+1 % 5",selectedIndex+1 % 5)
        if(!autoFind || (((selectedIndex+1) % 5) === 0)){
          this.setState({
            selectedIndex:0,
            loading: false,
            alert: <HsmErrorAlert error={error} onConfirm={() => this.setState({alert: null})} />
          });
          return;
        }else{
          this.loadCertificatesClicked(selectedIndex+1);
        }
      });
  }

  changed(key, val, selectedIndex) {
    let clone = Object.assign({}, this.props.value);
    clone[key] = val;

    if (key === "hsmType") {
      clone.certificate = null;
      this.setState({certificateList: null, autoFind:false});
    }

    if (!clone.hsmType)
      clone.hsmType = this.defaultHsmType;

    if(this.state.autoFind && (selectedIndex === 0 || selectedIndex)){
      clone.hsmType = this.state.typeList[selectedIndex];
    }

    if (this.props.onChange) {
      this.props.onChange(clone);
    }
  }

  handleChangeSmartCartBrand(e) {
    if (this.props.togglePinInput) {
      this.props.togglePinInput(false);
    }
    this.changed("hsmType", e.target.value)
  }

  render() {

    let hsmTypeList = [
      {label: "Akis", value: "akis"},
      {label: "GemSafe", value: "gemsafe"},
      {label: "Seimens", value: "seimens"},
      {label: "StarCOS", value: "starcos"},
      {label: "Aladdin", value: "aladdin"}
      ];

    return <Container>
      {this.state.alert}
      <Row>
        <Label sm={12} md={3} lg={3}>Akıllı kart markası</Label>
        <Col sm={12} md={5} lg={5}>
          <Input type="select" disabled={this.props.disabled} value={(this.props.value && this.props.value.hsmType) || this.defaultHsmType}
                 onChange={(e) => {
                   this.handleChangeSmartCartBrand(e)
                 }}>
            {hsmTypeList.map((e, i) => <option key={i} value={e.value}>{e.label}</option>)}
          </Input>
        </Col>
        <Col sm={12} md={4} lg={4}>
          <NormalButton disabled={this.props.disabled} color="primary" faIcon="fa-sync-alt" onClick={()=>this.loadCertificatesClicked(0)} style={{width: "100%"}}>
            Sertifikaları getir
          </NormalButton>
        </Col>
      </Row>
      <Row>
        {this.state.certificateList && this.props.value && this.props.value.certificate ?
          this.renderCertificateSelecter() :
          this.renderEmptyCertificateSelector()}
      </Row>
		</Container>
  }

  renderCertificateSelecter() {

    let keyUsageMap = {
      DIGITAL_SIGNATURE: "Dijital imza",
      NON_REPUDIATION: "Reddedilememe",
      KEY_ENCIPHERMENT: "Anahtar şifreleme",
      DATA_ENCIPHERMENT: "Veri şifreleme",
      KEY_AGREEMENT: "Anahtar anlaşması",
      KEY_CERT_SIGN: "Sertifika imzalama",
      CRL_SIGN: "Sertifia iptal listesi imzalama",
      ENCIPHER_ONLY: "Sadece şifreleme",
      DECIPHER_ONLY: "Sadece çözme",
    };

    return <Container>
      <Row>
        <Col sm={12}>
          <Input type="select" disabled={this.props.disabled} value={this.props.value.certificate.keyId}
                 onChange={(e) => {this.changed("certificate", this.state.certificateList.find((l) => (l.keyId === e.target.value)))}}>
            {this.state.certificateList.map(e => <option key={e.keyId} value={e.keyId}>{e.commonName}</option>)}
          </Input>
        </Col>
      </Row>
      {this.props.value && this.props.value.certificate &&
      <Container>
        <Row>
          <Col sm={12} md={4}>
            <label>Ortak ad</label>
          </Col>
          <Col sm={12} md={8}>
            {this.props.value.certificate.commonName}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4}>
            <label>Seri no</label>
          </Col>
          <Col sm={12} md={8}>
            {this.props.value.certificate.serial}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4}>
            <label>Geçerlilik baslangıcı</label>
          </Col>
          <Col sm={12} md={8}>
            {new Date(this.props.value.certificate.validFrom).toLocaleString()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4}>
            <label>Geçerlilik sonu</label>
          </Col>
          <Col sm={12} md={8}>
            {new Date(this.props.value.certificate.expiresOn).toLocaleString()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4}>
            <label>Anahtar kullanımı</label>
          </Col>
          <Col sm={12} md={8}>
            <ul>
              {this.props.value.certificate.keyUsage.map((element, index) => {
                return <li key={index}>{keyUsageMap[element]}</li>
              })}
            </ul>
          </Col>
        </Row>
      </Container>
      }
    </Container>
  }

  renderEmptyCertificateSelector() {
    return <Col sm={12}>
      <div style={{minHeight: '180px', position: 'relative'}}>
        {!this.state.loading && <ReactErrorTop type="usb" style={{width: '90px', height: '90px'}} transparent/>}
        {this.state.loading && <ReactLoadingTop style={{width: '90px', height: '90px'}} transparent/>}
    </div>
    </Col>
  }
}

export default HsmCertificateInput;
